import "../friends/friends.scss";
import { useFriends } from "./hooks/useFriends";
import FriendList from "./components/FriendList";
import UnfriendModal from "./components/UnfriendModal";

const Friends = () => {
    const { 
        friends, 
        isLoading, 
        error, 
        modalState, 
        handleUnfriendClick 
    } = useFriends();

    return (
        <div className="friends">
            <h3>
              Your Friends
            </h3>

            <FriendList 
                isLoading={isLoading}
                error={error}
                friends={friends}
                onUnfriendClick={handleUnfriendClick}
            />

            <UnfriendModal 
                isOpen={modalState.isOpen}
                onConfirm={modalState.confirm}
                onCancel={modalState.cancel}
            />
        </div>
    );
};

export default Friends;